<div class="who-we-are">

    <!-- Hero -->
    <section class="hero">
        <div class="container hero-grid">
            <div class="hero-copy">
                <h1 class="hero-title">Todo lo que <span class="accent">ocurre</span> cerca de ti, en un solo lugar.
                </h1>
                <p class="section-text">Descubre eventos, compra entradas y organiza experiencias desde una única
                    plataforma.</p>
                <div class="actions">
                    <button class="primary-button solid btn-lok" (click)="goToEvents()">
                        Descubrir eventos <i class="fa-light fa-arrow-right"></i>
                    </button>
                    <button class="cancel-button btn-lok" (click)="goToOrganizer()">
                        Crear un evento <i class="fa-light fa-arrow-right"></i>
                    </button>
                </div>
                <div class="hero-highlights">
                    <div class="highlight" *ngFor="let item of heroHighlights">
                        <i class="fa-light {{ item.icon }}"></i>
                        <p class="m-0"><strong>{{ item.title }}</strong><br>{{ item.text }}</p>
                    </div>
                </div>
            </div>
            <!-- Mockups generados a partir de capturas reales de Citylok -->
            <div class="hero-media">
                <img class="hero-media-web" src="assets/img/mockups/mockup-web-explorar.webp"
                    alt="Buscador de eventos de Citylok en escritorio" />
                <img class="hero-media-app" src="assets/img/mockups/mockup-app-mapa.webp"
                    alt="App de Citylok mostrando los eventos cercanos en el mapa" />
            </div>
        </div>
    </section>

    <!-- Para organizadores -->
    <section class="section section-organizers">
        <div class="container">
            <p class="eyebrow">Para organizadores</p>
            <h2 class="section-title">Todo lo que necesitas para gestionar tus eventos.</h2>
            <div class="features-grid">
                <div class="feature-card" *ngFor="let feature of organizerFeatures">
                    <i class="fa-light {{ feature.icon }}"></i>
                    <p class="feature-title">{{ feature.title }}</p>
                    <p class="feature-text m-0">{{ feature.text }}</p>
                </div>
            </div>
            <div class="actions actions-center">
                <button class="primary-button solid btn-lok" (click)="goToOrganizer()">
                    Empieza a organizar <i class="fa-light fa-arrow-right"></i>
                </button>
            </div>
        </div>
    </section>

    <!-- Panel de control -->
    <section class="section section-control">
        <div class="container control-grid">
            <div class="control-copy">
                <p class="eyebrow">Todo bajo control</p>
                <h2 class="section-title">Gestiona, analiza y haz crecer tus eventos.</h2>
                <p class="section-text">Desde tu panel tendrás una visión completa de todo lo que ocurre.</p>
                <ul class="check-list">
                    <li *ngFor="let item of controlHighlights">
                        <i class="fa-light fa-check"></i>
                        <span>{{ item }}</span>
                    </li>
                </ul>
            </div>
            <img class="control-media" src="assets/img/mockups/mockup-web-panel.webp"
                alt="Panel de control de Citylok con el listado de eventos y sus entradas vendidas" />
        </div>
    </section>

    <!-- Para usuarios -->
    <section class="section section-users">
        <div class="container">
            <p class="eyebrow">Para usuarios</p>
            <h2 class="section-title">Descubre todo lo que pasa cerca de ti.</h2>
            <div class="features-grid">
                <div class="feature-card" *ngFor="let feature of userFeatures">
                    <i class="fa-light {{ feature.icon }}"></i>
                    <p class="feature-title">{{ feature.title }}</p>
                    <p class="feature-text m-0">{{ feature.text }}</p>
                </div>
            </div>
        </div>
    </section>

    <!-- Categorías -->
    <section class="section section-categories" *ngIf="categorias?.length">
        <div class="container">
            <h2 class="section-title">¿Qué tipo de eventos puedes encontrar u organizar?</h2>
            <div class="categories-grid">
                <a class="category-card" *ngFor="let categoria of categorias"
                    [routerLink]="['/category', categoria.slug]">
                    <i class="fa-light {{ categoria.icon }}"></i>
                    <span>{{ categoria.name }}</span>
                </a>
                <a class="category-card category-card--more" [routerLink]="['/results']">
                    <i class="fa-light fa-grid-2"></i>
                    <span>Ver más</span>
                </a>
            </div>
        </div>
    </section>

    <!-- Agenda viva -->
    <section class="section section-ecosystem">
        <div class="container ecosystem-panel">
            <div class="ecosystem-diagram">
                <div class="diagram-ring">
                    <div class="diagram-center">
                        <img src="assets/img/citylok_logo.png" alt="Citylok" />
                    </div>
                    <div class="diagram-node" *ngFor="let node of ecosystemNodes; let i = index"
                        [ngClass]="'diagram-node-' + i">
                        <i class="fa-light {{ node.icon }}"></i>
                        <span>{{ node.name }}</span>
                    </div>
                </div>
            </div>
            <div class="ecosystem-copy">
                <p class="eyebrow">Mucho más que una plataforma de ticketing</p>
                <h2 class="section-title">Somos la agenda viva de tu ciudad.</h2>
                <p class="section-text">Citylok conecta organizadores, ayuntamientos, asociaciones, comercios y
                    ciudadanos en una única agenda de eventos.</p>
                <p class="section-text m-0">No solo vendemos entradas. Hacemos visibles los eventos locales.</p>
            </div>
            <!-- Fuera de .ecosystem-copy para poder colocar el diagrama entre el
                 texto y los beneficios cuando el panel pasa a una columna -->
            <div class="benefits-grid">
                <div class="benefit" *ngFor="let benefit of ecosystemBenefits">
                    <i class="fa-light {{ benefit.icon }}"></i>
                    <p class="m-0"><strong>{{ benefit.title }}</strong><br>{{ benefit.text }}</p>
                </div>
            </div>
        </div>
    </section>

    <!-- CTA -->
    <section class="section section-cta">
        <div class="container cta-grid">
            <div class="cta-card cta-card--organizer">
                <div class="cta-copy">
                    <p class="eyebrow">¿Quieres organizar un evento?</p>
                    <p class="cta-title">Llega a más personas y haz crecer tu evento.</p>
                    <button class="primary-button solid btn-lok" (click)="goToOrganizer()">Crear evento gratis</button>
                </div>
                <img class="cta-media" src="assets/img/mockups/mockup-app-panel.webp"
                    alt="Panel de control de Citylok en el móvil, creando y siguiendo un evento" />
            </div>
            <div class="cta-card cta-card--user">
                <div class="cta-copy">
                    <p class="eyebrow">¿Buscas planes?</p>
                    <p class="cta-title">Descubre experiencias cerca de ti.</p>
                    <button class="primary-button solid btn-lok" (click)="goToEvents()">Explorar eventos <i
                            class="fa-light fa-arrow-right"></i></button>
                </div>
                <img class="cta-media" src="assets/img/mockups/mockup-app-explorar.webp"
                    alt="Listado de eventos en la app de Citylok" />
            </div>
        </div>
    </section>

    <!-- Confianza -->
    <section class="section section-partners">
        <div class="container">
            <p class="partners-title">Miles de organizadores y usuarios ya confían en Citylok</p>
            <div class="partners-logos">
                <div class="partner-logo" *ngFor="let logo of partnerLogos">
                    <img fallimg src="assets/img/business/{{ logo }}" alt="Organizador que confía en Citylok" />
                </div>
            </div>
        </div>
    </section>

</div>
